import { FC, ReactNode } from 'react';
import NyhetslistaKompakt from '../components/Nyhetslista/NyhetslistaKompakt';
import { ContentResponse } from '../types/shared';
import { NyhetsBlockResponse } from '../types/blocks';

interface INyhetsBlock {
  contentResponse: ContentResponse;
}

const NyhetsBlock: FC<INyhetsBlock> = ({ contentResponse }): ReactNode => {
  const nyhetsarkivsidaResponse = contentResponse.content as NyhetsBlockResponse;
  return (
    <NyhetslistaKompakt nyhetslista={nyhetsarkivsidaResponse}></NyhetslistaKompakt>
  );
};

export default NyhetsBlock;
